import BannerCountdown from '@/components/BannerCountdown.vue';
import { mountCoreVueApp } from '@/entrypoints/helpers/core-vue-app';

const initCountdownBanner = async (
  mountSelector: string,
  element: HTMLElement
) => {
  const { endDate, cardClasses } = element.dataset;

  await mountCoreVueApp(
    BannerCountdown,
    mountSelector,
    { endDate, cardClasses },
    null,
    { noClients: true }
  );
};

const setUpListener = (countdownWrapper: HTMLElement) => {
  const { removeSection } = countdownWrapper.dataset;
  const removeSectionOnTimesUp = removeSection === 'true';

  countdownWrapper?.addEventListener('time-is-up', () => {
    // hide the countdown wrapper
    countdownWrapper.classList?.add('opacity-0');

    if (removeSectionOnTimesUp) {
      countdownWrapper.closest('.js-async-countdown-banner')?.remove();
    }
  });
};

const setupCountdownBanner = async () => {
  const mountSelector = '.js-countdown-wrapper';
  const countdownWrapper =
    document.querySelector<HTMLDivElement>(mountSelector);

  if (!countdownWrapper) return;

  initCountdownBanner(mountSelector, countdownWrapper);
  setUpListener(countdownWrapper);
};

setupCountdownBanner();
